<template>
    <v-card class="pa-0 ma-0" width="322" height="154">
        <v-layout row  wrap>
            <v-flex xs2 pt-4 pl-2>
                <v-avatar size="45" :tile="false" color="grey lighten-4">
                    <img :src="push.logo" alt="avatar">
                </v-avatar>
            </v-flex>
            <v-flex xs9 pt-3 pl-3>
                <div >
                    <div class="subheading">{{push.titulo}}</div>
                    <div style="overflow: auto; width: 200px;">
                        <span class="grey--text caption">{{push.mensagem}}</span>
                        <!--<v-img class="ma-3" :src="push.imagem" aspect-ratio="1.7"></v-img>-->
                    </div>
                </div>
                <v-divider class="mt-3"></v-divider>
                <v-btn flat class="ma-0 mt-2 mb-2" block>{{push.label}}</v-btn>
            </v-flex>
        </v-layout>


    </v-card>
</template>

<script>

export default {
    props: ['push'],
    data(){
        return{

        }
    }
}
</script>




// WEBPACK FOOTER //
// src/components/user/push/layout/layoutpush.vue